export function generateAsaResponse(type, data) {
  // Mock AI Logic to generate context-aware responses
  
  if (type === 'sakit') {
    const { keluhan, sudahBerobat, sejak, estimasiSembuh } = data;
    
    let obatText = sudahBerobat === 'sudah' 
      ? 'Syukurlah kalau sudah ke dokter/minum obat. Obatnya tolong diminum sampai habis ya.' 
      : 'Tolong sempatkan ke klinik terdekat atau minimal istirahat yang cukup dan minum vitamin ya.';

    let doaText = 'Semoga segera membaik.';
    const k = keluhan.toLowerCase();
    
    if (k.includes('demam') || k.includes('panas')) doaText = 'Semoga panasnya cepat turun dan tubuh segera fit kembali.';
    if (k.includes('flu') || k.includes('batuk')) doaText = 'Semoga flu dan batuknya cepat reda, perbanyak minum air hangat ya.';
    if (k.includes('perut') || k.includes('diare') || k.includes('mual')) doaText = 'Semoga pencernaannya cepat pulih, jaga pola makan dulu ya.';
    if (k.includes('kepala')) doaText = 'Semoga sakit kepalanya cepat hilang, coba istirahatkan matanya dari layar.';

    return `Ya ampun, sedih mendengarnya. ${doaText} ${obatText} Pekerjaan biar dicover tim yang lain dulu, kamu fokus ke pemulihan saja sampai tanggal ${estimasiSembuh}. Lekas sembuh!`;
  }

  if (type === 'izin') {
    const { alasan, dari, sampai, jenisIzin } = data;
    
    let teguran = 'Tolong ingat ya, jatah izin bulanan tidak boleh sering-sering dipakai kalau bukan hal mendesak agar alur produksi tetap lancar.';
    let konteksIzin = 'Saya doakan urusannya dilancarkan.';
    
    const a = alasan.toLowerCase();
    if (a.includes('keluarga') || a.includes('anak') || a.includes('istri') || a.includes('suami')) {
      konteksIzin = 'Keluarga memang prioritas, semoga urusan keluarga berjalan lancar dan semua sehat.';
    } else if (a.includes('nikah') || a.includes('kondangan')) {
      konteksIzin = 'Selamat ya untuk acaranya, sampaikan salam bahagia dari tim Satala!';
      teguran = 'Tapi setelah acara selesai, kembali fokus dan genjot semangat kerjanya ya!';
    } else if (a.includes('surat') || a.includes('bank') || a.includes('ktp')) {
      konteksIzin = 'Semoga urusan administrasinya cepat beres dan tidak antre panjang.';
    }

    return `Baik, izin ${jenisIzin} dari tanggal ${dari} s.d. ${sampai} sudah saya rekap di sistem. ${konteksIzin} ${teguran}`;
  }

  return "Terima kasih atas konfirmasinya. Data sudah tercatat di sistem Satala.";
}
